import type { HelpFile } from '../../types/help'
import { K8sConfigCardTestIds } from '../../../testids/K8sConfigCardTestIds'

export const k8sConfigCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [K8sConfigCardTestIds.k8sConfigCard]:
      'Kubernetes-Konnektor-Konfiguration — API-Endpunkt, Namespace und Authentifizierung für Bereitstellungsänderungen am Cluster.',
    [K8sConfigCardTestIds.cardTitleK8sConfig]: null,
    [K8sConfigCardTestIds.btnCreateK8sConfig]: null,
    [K8sConfigCardTestIds.btnEditK8sConfig]: null,
    [K8sConfigCardTestIds.selectK8sAuthType]:
      'Authentifizierungsverfahren für die Kommunikation mit dem Cluster — Bearer-Token, kubeconfig-Kontext oder Service-Account im Cluster.',
  },
}
